export const LanguageMap: { [key: string]: string } = {
  en: 'English',
  de: 'German',
  fr: 'French',
  es: 'Spanish',
  it: 'Italian',
  pt: 'Portuguese',
  ru: 'Russian',
  zh: 'Chinese',
  ja: 'Japanese',
  ko: 'Korean',
  ar: 'Arabic',
  vi: 'Vietnamese',
  th: 'Thai',
  tr: 'Turkish',
  nl: 'Dutch',
  sv: 'Swedish',
  no: 'Norwegian',
  fi: 'Finnish',
  da: 'Danish',
  pl: 'Polish',
  cs: 'Czech',
  sk: 'Slovak',
  hu: 'Hungarian',
  el: 'Greek',
  he: 'Hebrew',
  ro: 'Romanian',
  bg: 'Bulgarian',
  sr: 'Serbian',
  hr: 'Croatian',
  uk: 'Ukrainian',
  lt: 'Lithuanian',
  lv: 'Latvian',
  et: 'Estonian',
  is: 'Icelandic',
  ga: 'Irish',
  cy: 'Welsh',
};
